import { Grid } from "antd";
import React from "react";
import { H3, H6 } from "../NormalFonts";
import { TitleProps } from "./data";
import styles from "./styles.module.scss";

const Title: React.FC<TitleProps> = ({
  title = "Title",
  subtitle = "Subtitle",
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  return (
    <div
      className={`${styles.titleContainer} ${screens.sm ? "" : styles.mobile}`}
    >
      <H3 className={styles.title} weight="heavy" color="var(--primary)">
        {title}
      </H3>
      {screens.sm ? (
        <div className={styles.subContainer}>
          <div className={styles.border} />
          <H6
            className={styles.subtitle}
            weight="medium"
            color="var(--primary-10)"
          >
            {subtitle}
          </H6>
        </div>
      ) : null}
    </div>
  );
};

export default Title;
